"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@opensea/next-ui-kit";
import { useTranslations } from "next-intl";
import { useProfileTokensSelectionStore } from "../ProfileTokensSelectionProvider";
export function ProfileTokensSelectionClearAll() {
  const $ = _c(5);
  const resetSelections = useProfileTokensSelectionStore(_temp);
  const t = useTranslations("ProfileTokensSelectionClearAll");
  let t0;
  if ($[0] !== t) {
    t0 = t("clearAll");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== resetSelections || $[3] !== t0) {
    t1 = <Button aria-label="Clear all selected tokens" onClick={resetSelections} size="sm" variant="tertiary">{t0}</Button>;
    $[2] = resetSelections;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}
function _temp(state) {
  return state.resetSelections;
}